import NotificationsByPersonEditModalView from "./notifications_by_person-edit.html";



angular.module("notifications_by_person")

    .controller('NotificationsByPersonListCtrl', ['$stateParams', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$state', '$uibModal', 'logService', function ($stateParams, $rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $state, $uibModal, logService) {

        let eventId = null;
        let event = null;
        if (typeof ($stateParams.id) !== 'undefined') {
            $scope.showEventCombo = false;
            eventId = $stateParams.id;
            Restangular.one('Events', $stateParams.id).get().then(function (results) {
                event = results;
            });
        } else {
            $scope.showEventCombo = true;
            var options = {
                searchName: "",
                is_template: false
            };
            Restangular.all('Events/AllEvents').getList(options).then(function (events) {
                logService.debug($scope.selectEvents);
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('informations.all')
                });
            });

        }
        
        $rootScope.title = $filter('translate')('notifications_by_person.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('notifications.list') }
        ];

        $scope.search = {
            subject: "",
            date_from: null,
            date_to: null,
            event_id : eventId
        };

        $scope.sendStatus = [
            { text: $filter('translate')('notifications.sending'), value: 'pending', checked: false },
            { text: $filter('translate')('notifications.sent'), value: 'sent', checked: false },
            { text: $filter('translate')('notifications.sent_error'), value: 'error', checked: false }
        ];
       /* $scope.sendToGroup = [
            { text: $filter('translate')('notifications.users'), value: 'users', checked: false },
            { text: $filter('translate')('notifications.guests'), value: 'guests', checked: false },
            { text: $filter('translate')('notifications.staff'), value: 'staff', checked: false },
            { text: $filter('translate')('notifications.work_team'), value: 'work_team', checked: false }
        ];*/
        

        $scope.gridOptionNotifications = {
            pdfTitle: $filter('translate')('notifications.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            enableFiltering: false,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'state', displayName: " ", enableFiltering: false, enableHiding: false, enableColumnMenu: false, width: 90,
                    cellTemplate: '<div class="ui-grid-cell-contents"><span ng-if="row.entity.state==\'error\'" class="label label-danger">' + $filter('translate')('notifications.sent_error') + '</span><span ng-if="row.entity.state==\'pending\' || row.entity.state==\'running\'" class="label label-warning">' + $filter('translate')('notifications.sending') + '</span><span ng-if="row.entity.state==\'sent\'" class="label label-success">' + $filter('translate')('notifications.sent') +'</span></div>',
                },
                {
                    name: 'FK_notifications_to_notifications_emails.date', displayName: $filter('translate')('notifications.date'), maxWidth: 125, minWidth: 80,
                    type: 'FK_notifications_to_notifications_emails.date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                    customFormatFn: function (value) {
                        if (value !== null) {
                            var fecha = new Date(value);
                            return $filter('FK_notifications_to_notifications_emails.date')(fecha, 'dd/MM/yyyy');
                        }
                        return "";
                    }   ,                
                    enableFiltering: false, enableColumnMenu: false,enableSorting: false
                },
                {
                    name: 'FK_notifications_to_notifications_emails.FK_notifications_emails_events.name',
                    displayName: $filter('translate')('notifications.event'), enableFiltering: false, enableHiding: false, enableColumnMenu: false, enableSorting: false,
                    visible: (eventId != null ? false : true)
                },
                { name: 'FK_notifications_to_notifications_emails.subject', displayName: $filter('translate')('notifications.subject'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, enableSorting: false },
                { name: 'mails', displayName: $filter('translate')('notifications.mails'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('notifications.button_view'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-eye" },
                    ], { cssClass: "pull-right" })
                },
            ],
            getData: function (options) {
                options.subject = $scope.search.subject;
                options.email = $scope.search.email;
                options.date_from = $scope.search.date_from;
                options.date_to = $scope.search.date_to;
                options.event_id = $scope.search.event_id;
                if (eventId != null) options.event_id = eventId;
                options.states = _.chain($scope.sendStatus)
                    .filter(function (status) { return status.checked; })
                    .map(function (status) { return status.value; })
                    .value();
                logService.debug(options.states);
                return Restangular.all('NotificationsEmails/GetNotificationByUser').getList(options);
            }
            
        };

        $scope.searchNotifications = function () {
            if (angular.isDefined($scope.gridOptionNotifications.loadData)) {
                $scope.gridOptionNotifications.loadData(false);
            }
        };

        $scope.clearform = function () {
            $scope.search = {
                event_id: null,
                email: "",
                subject: "",
                date_from: null,
                date_to: null
            };
            $scope.sendStatus = [
                { text: $filter('translate')('notifications.sending'), value: 'pending', checked: false },
                { text: $filter('translate')('notifications.sent'), value: 'sent', checked: false },
                { text: $filter('translate')('notifications.sent_error'), value: 'error', checked: false }
            ];

            $scope.gridOptionNotifications.loadData();
        }


        $scope.goToEdit = function (rowEntity) {
            if (eventId != null) {
                $state.go("events.edit.notifications_by_person.edit", { id: eventId, notificationId: rowEntity.FK_notifications_to_notifications_emails.id });
            } else {
                //$state.go("notifications_by_person.edit", { notificationId: rowEntity.id });
                //Popup.
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: NotificationsByPersonEditModalView,
                    size: "lg",
                    controller: "NotificationsByPersonEditModalCtrl",
                    scope: $scope,
                    resolve: {
                        notificationId: function () {
                            return rowEntity.FK_notifications_to_notifications_emails.id;
                        },
                        notificationToId: function () {
                            return rowEntity.id;
                        }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                    $scope.gridOptionNotifications.loadData(false);
                    if (!$scope.$$phase) $scope.$apply();
                    $scope.$parent.loadInfo($stateParams.id);
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });
            }
        };


    }])

;